import Layout from '@/layout';
var productRouter = {
  path: '/product',
  component: Layout,
  redirect: '/product/list',
  name: 'Product',
  meta: {
    title: '商品',
    icon: 'clipboard'
  },
  children: [{
    path: 'list',
    component: function component() {
      return import('@/views/product/index');
    },
    name: 'ProductList',
    meta: {
      title: '商品列表',
      icon: ''
    }
  }, {
    path: 'library',
    component: function component() {
      return import('@/views/product/library/index');
    },
    name: 'ProductLibrary',
    meta: {
      title: '商品库',
      icon: ''
    }
  }, {
    path: 'cardVerify',
    component: function component() {
      return import('@/views/product/cardVerify/index');
    },
    name: 'ProductCardVerify',
    meta: {
      title: '卡券核销',
      icon: ''
    }
  }, {
    path: 'cdkey',
    component: function component() {
      return import('@/views/product/cdkey/index');
    },
    name: 'Cdkey',
    meta: {
      title: '卡密管理',
      icon: ''
    }
  }, {
    //id:卡密库id
    path: 'cdkey/creatCdkey/:id?/:name?',
    component: function component() {
      return import('@/views/product/cdkey/creatCdkey');
    },
    name: 'creatCdkey',
    meta: {
      title: '卡密添加',
      noCache: true,
      activeMenu: "/product/cdkey"
    },
    hidden: true
  }, {
    path: 'classify',
    component: function component() {
      return import('@/views/product/category/index');
    },
    name: 'ProductClassify',
    meta: {
      title: '商品分类',
      icon: ''
    }
  }, {
    path: 'attr',
    component: function component() {
      return import('@/views/product/attr/index');
    },
    name: 'ProductAttr',
    meta: {
      title: '商品规格',
      icon: ''
    }
  }, {
    path: 'brand',
    component: function component() {
      return import('@/views/product/brand/index');
    },
    name: 'ProductBrand',
    meta: {
      title: '品牌管理',
      icon: ''
    }
  }, {
    path: 'comment',
    component: function component() {
      return import('@/views/product/comment/index');
    },
    name: 'ProductComment',
    meta: {
      title: '商品评论',
      icon: ''
    }
  }, {
    //id:商品id，isDisabled：是否能编辑(1不能，2能)，isCopy：是否是采集商品(1是，2不是),productType:商品类型,isEdit:是编辑还是复制商品
    path: 'list/creatProduct/:id?/:isDisabled/:isCopy/:productType/:editOrCopy?',
    component: function component() {
      return import('@/views/product/creatProduct/index');
    },
    name: 'ProductCreate',
    meta: {
      title: '商品添加',
      noCache: true,
      activeMenu: "/product/list"
    },
    hidden: true
  }, {
    path: 'guarantee/group',
    component: function component() {
      return import('@/views/product/guarantee/index');
    },
    name: 'ProductGuarantee',
    meta: {
      title: '保障服务组合',
      icon: ''
    }
  }, {
    path: 'platguarantee/index',
    component: function component() {
      return import('@/views/product/platguarantee/index');
    },
    name: 'ProductPlatguarantee',
    meta: {
      title: '保障服务',
      icon: ''
    }
  }, {
    path: 'label',
    component: function component() {
      return import('@/views/product/label/index');
    },
    name: 'ProductLabel',
    meta: {
      title: '商品标签',
      icon: ''
    }
  }, {
    path: 'tag',
    component: function component() {
      return import('@/views/product/tag/index');
    },
    name: 'ProductTag',
    meta: {
      title: '商品标签管理',
      icon: ''
    }
  }, {
    path: 'tag/creatTag/:id?',
    component: function component() {
      return import('@/views/product/tag/creatTag');
    },
    name: 'creatTag',
    meta: {
      title: '添加标签',
      noCache: true,
      activeMenu: '/product/tag'
    },
    hidden: true
  }
  // {
  //   path: 'reservation',
  //   component: () => import('@/views/product/reservation/index'),
  //   name: 'Reservation',
  //   meta: { title: '预约设置', icon: '' },
  //   children: [
  //     {
  //       path: 'toDoorService',
  //       component: () => import('@/views/product/reservation/ToDoorService/index'),
  //       name: 'ToDoorService1',
  //       meta: { title: '上门服务', icon: '' },
  //     },
  //     {
  //       path: 'inStoreService',
  //       component: () => import('@/views/product/reservation/inStoreService/index'),
  //       name: 'InStoreService',
  //       meta: { title: '到店服务', icon: '' },
  //     }
  //   ],
  // },
  ]
};
export default productRouter;